<main class="page-container banks-page">
  <app-page-header
    title="Bancos e integraciones"
    description="Administra bancos e integraciones disponibles para todas las empresas."
  >
    <app-button variant="primary" size="large" (clicked)="openNewBank()"
      ><i button-icon class="fa-solid fa-building-columns"></i> Nuevo banco</app-button
    >
  </app-page-header>

  <section class="summary-grid" aria-label="Resumen de bancos">
    <app-summary-card
      label="Bancos activos"
      [value]="activeCount().toString()"
      icon="fa-solid fa-building-columns"
      tone="green"
    />
    <app-summary-card
      label="Cuentas conectadas"
      [value]="accountCount().toString()"
      icon="fa-solid fa-wallet"
      tone="blue"
    />
    <app-summary-card
      label="Requieren atención"
      [value]="reviewCount().toString()"
      icon="fa-solid fa-triangle-exclamation"
      tone="warning"
    />
  </section>

  @if (testMessage()) {
    <div class="toast"><i class="fa-solid fa-circle-check"></i>{{ testMessage() }}</div>
  }

  <section class="data-section-card content-card banks-table-card">
    <div class="content-heading">
      <div>
        <h2>Catálogo de bancos</h2>
        <p>Expande un banco para consultar y administrar sus integraciones.</p>
      </div>
      <span class="result-count">{{ totalItems() }} bancos</span>
    </div>
    <div class="toolbar">
      <app-search-input
        class="wide-search"
        [(value)]="searchInput"
        placeholder="Buscar banco o código"
        (search)="onSearch()"
      />
      <app-select
        [value]="statusFilter"
        (valueChange)="onStatusChange($event)"
        aria-label="Filtrar por estado"
        [options]="statusOptions"
      >
      </app-select>
    </div>

    @if (!mobileService.isMobile()) {
      <app-data-table-paginado
        [columns]="columns"
        [data]="rows()"
        [loading]="loadingTable"
        [actions]="actions"
        [showActions]="true"
        [expandable]="true"
        rowKey="id"
        [page]="page()"
        [pageSize]="pageSize()"
        [totalItems]="totalItems()"
        [pageSizeOptions]="pageSizeOptions"
        [showRowHover]="true"
        emptyMessage="No hay bancos registrados."
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
        (action)="onAction($event)"
        (expandChange)="onExpand($event)"
      >
        <ng-template #expandedRow let-bank>
          <div class="integration-panel">
            <div class="integration-panel-header">
              <div>
                <strong>{{ bank.nombre }} · Integraciones</strong
                ><span>{{ bank.integraciones.length }} configuradas</span>
              </div>
              <app-button variant="outlined" size="small" (clicked)="openNew(bank)"
                ><i button-icon class="fa-solid fa-plus"></i> Agregar integración</app-button
              >
            </div>
            @if (bank.integraciones.length) {
              <div class="integration-list">
                @for (integration of bank.integraciones; track integration.id) {
                  <div class="integration-row">
                    <div class="integration-main">
                      <span class="integration-icon"><i class="fa-solid fa-plug"></i></span>
                      <div>
                        <strong>{{ integration.tipoProveedor }}</strong
                        ><span
                          >{{ integration.tipoAutenticacion }} · {{ integration.urlBase }}</span
                        >
                      </div>
                    </div>
                    <span
                      class="status"
                      [class.active]="integration.estaActivo"
                      [class.inactive]="!integration.estaActivo"
                      [class.review]="integration.estadoUltimaPrueba === 'PENDIENTE'"
                      ><i></i
                      >{{
                        integration.estaActivo
                          ? integration.estadoUltimaPrueba === 'PENDIENTE'
                            ? 'En revisión'
                            : 'Activo'
                          : 'Inactivo'
                      }}</span
                    >
                    <span class="integration-date">{{
                      integration.ultimaSincronizacion || 'Sin sincronización'
                    }}</span>
                    <div class="integration-actions">
                      <app-button
                        variant="text"
                        size="small"
                        (clicked)="testConnection(integration)"
                        [loading]="testingId === integration.id"
                        ><i button-icon class="fa-solid fa-plug"></i> Probar</app-button
                      ><app-button
                        variant="text"
                        size="small"
                        (clicked)="editIntegration(integration)"
                        ariaLabel="Editar integración"
                        ><i button-icon class="fa-solid fa-pen"></i></app-button
                      ><app-button
                        variant="text"
                        size="small"
                        (clicked)="toggleIntegration(integration)"
                        [color]="integration.estaActivo ? 'blue' : 'red'"
                        [hoverColor]="integration.estaActivo ? 'blue' : 'red'"
                        [hoverBorder]="true"
                        ariaLabel="Cambiar estado"
                        ><i
                          button-icon
                          class="fa-solid"
                          [class.fa-toggle-on]="integration.estaActivo"
                          [class.fa-toggle-off]="!integration.estaActivo"
                        ></i
                      ></app-button>
                    </div>
                  </div>
                }
              </div>
            } @else {
              <div class="integration-empty">
                <i class="fa-solid fa-plug-circle-xmark"></i
                ><span>Banco sin integración configurada.</span
                ><app-button variant="text" size="small" (clicked)="openNew(bank)"
                  >Configurar ahora</app-button
                >
              </div>
            }
          </div>
        </ng-template>
      </app-data-table-paginado>
    } @else {
      <app-card-list
        [items]="rows()"
        [loading]="loadingTable"
        [emptyMessage]="'No hay bancos registrados.'"
        [showPagination]="true"
        [page]="page()"
        [pageSize]="pageSize()"
        [totalItems]="totalItems()"
        [pageSizeOptions]="pageSizeOptions"
        (pageChange)="onPageChange($event)"
        (pageSizeChange)="onPageSizeChange($event)"
      >
        <ng-template #card let-bank>
          <div class="card-list-item">
            <div class="card-list-item-header">
              <strong>{{ bank.nombre }}</strong>
              <span class="card-list-item-code">{{ bank.codigo }}</span>
            </div>
            <div class="card-list-item-body">
              <div class="card-list-item-row">
                <span
                  class="badge"
                  [class]="getBadgeClass(bank.estaActivo ? 'Activo' : 'Inactivo')"
                >
                  <span class="badge-dot"></span>

                  {{ bank.estaActivo ? 'Activo' : 'Inactivo' }}
                </span>
                <span
                  class="badge"
                  [class]="'integration-' + integrationStatusClass(bank.integrationStatus)"
                >
                  <span class="badge-dot"></span>
                  {{ bank.integrationStatus }}
                </span>
                <span class="card-list-item-secondary"
                  >{{ bank.integraciones.length }} integraciones</span
                >
              </div>
              <div class="card-list-item-details">
                <span class="card-list-item-label"
                  >Cuentas conectadas:
                  <span class="card-list-item-value">
                    {{ bank.cuentasConectadas }}
                  </span>
                </span>
                <span class="card-list-item-label"
                  >Última sincronización:
                  <span class="card-list-item-value">{{
                    bank.ultimaSincronizacion || 'Sin fecha'
                  }}</span>
                </span>
              </div>
            </div>
            <div class="card-list-item-actions">
              <app-button
                class="card-list-item-primary-action"
                variant="outlined"
                size="small"
                (clicked)="openNew(bank)"
                ><i button-icon class="fa-solid fa-plus"></i> Nueva integración</app-button
              ><app-button
                class="card-list-item-secondary-action"
                variant="text"
                size="small"
                shape="circle"
                ariaLabel="Editar banco"
                (clicked)="editBank(bank)"
                ><i button-icon class="fa-solid fa-pen"></i></app-button
              ><app-button
                class="card-list-item-secondary-action"
                variant="text"
                size="small"
                [ariaLabel]="bank.estaActivo ? 'Desactivar banco' : 'Activar banco'"
                (clicked)="toggleBank(bank)"
                [color]="bank.estaActivo ? 'blue' : 'red'"
                [hoverColor]="bank.estaActivo ? 'blue' : 'red'"
                [hoverBorder]="true"
                shape="circle"
                ><i
                  button-icon
                  class="fa-solid"
                  [class.fa-toggle-on]="bank.estaActivo"
                  [class.fa-toggle-off]="!bank.estaActivo"
                ></i
              ></app-button>
            </div>

            <button
              type="button"
              class="bank-card-integrations-toggle"
              [attr.aria-expanded]="isBankExpanded(bank.id)"
              (click)="toggleBankExpanded(bank.id)"
            >
              <span>
                <i class="fa-solid fa-plug"></i>
                {{ bank.integraciones.length }} integraciones
              </span>
              <i
                class="fa-solid"
                [class.fa-chevron-down]="!isBankExpanded(bank.id)"
                [class.fa-chevron-up]="isBankExpanded(bank.id)"
              ></i>
            </button>

            @if (isBankExpanded(bank.id)) {
              <app-bank-integrations-panel
                [bankName]="bank.nombre"
                [integrations]="bank.integraciones"
                [testingId]="testingId"
                (add)="openNew(bank)"
                (edit)="editIntegration($event)"
                (test)="testConnection($event)"
                (toggle)="toggleIntegration($event)"
              />
            }
          </div>
        </ng-template>
      </app-card-list>
    }
  </section>

  @if (showForm) {
    <app-modal-shell
      [title]="selectedBank ? 'Editar integración' : 'Nueva integración'"
      description="Configura proveedor y datos de conexión."
      size="medium"
      (closed)="closeForm()"
      ><form class="integration-form" (submit)="$event.preventDefault(); save()">
        @if (formError) {
          <div class="form-error" role="alert">{{ formError }}</div>
        }
        <label for="banks"
          >Banco
          <app-select
            [(ngModel)]="formBankId"
            name="bankId"
            [options]="bankOptions()"
            [disabled]="!!selectedBank"
            [clearable]="false"
            placeholder="Selecciona un banco"
            aria-label="Banco"
          /> </label
        ><label for="providers"
          >Tipo de proveedor
          <app-select
            [(ngModel)]="formProvider"
            name="provider"
            [options]="providerOptions"
            [clearable]="false"
            aria-label="Tipo de proveedor"
          />
        </label>
        <div class="form-row">
          <label for="url"
            >URL base<input
              [(ngModel)]="formUrl"
              name="url"
              placeholder="https://api.ejemplo.com"
              required /></label
          ><label>Versión API<input [(ngModel)]="formVersion" name="version" required /></label>
        </div>
        <label for="auth"
          >Tipo de autenticación
          <app-select
            [(ngModel)]="formAuth"
            name="auth"
            [options]="authOptions"
            [clearable]="false"
            aria-label="Tipo de autenticación"
          />
        </label>
        <div class="modal-actions">
          <app-button variant="outlined" type="button" (clicked)="closeForm()">Cancelar</app-button
          ><app-button variant="primary" htmlType="submit" [loading]="saving"
            >Guardar integración</app-button
          >
        </div>
      </form></app-modal-shell
    >
  }
  @if (showBankForm) {
    <app-modal-shell
      title="Nuevo banco"
      description="Registra banco en catálogo."
      size="medium"
      (closed)="closeBankForm()"
      ><form class="integration-form" (submit)="$event.preventDefault(); saveBank()">
        @if (formError) {
          <div class="form-error" role="alert">{{ formError }}</div>
        }
        <label
          >Nombre<input
            [(ngModel)]="bankName"
            name="bankName"
            placeholder="Banco del Pacífico"
            required /></label
        ><label
          >Código<input [(ngModel)]="bankCode" name="bankCode" placeholder="PACIFICO" required
        /></label>
        <div class="modal-actions">
          <app-button variant="outlined" type="button" (clicked)="closeBankForm()"
            >Cancelar</app-button
          ><app-button variant="primary" htmlType="submit" [loading]="saving"
            >Guardar banco</app-button
          >
        </div>
      </form></app-modal-shell
    >
  }
  @if (showConfirmation) {
    <app-confirmation-modal
      title="Confirmar cambio de estado"
      message="¿Está seguro de cambiar el estado de este banco?"
      (confirmed)="confirmToggle()"
      (cancelled)="cancelToggle()"
    ></app-confirmation-modal>
  }
  @if (loadingPage) {
    <app-loading [fullscreen]="true" label="Cargando bancos..."></app-loading>
  }
</main>
